import { AmplitudeExperimentProvider } from '@crehana/analytics';
import { getAmplitudeClientKey } from './utils';
import React, { FC } from 'react';

const ExperimentLayout: FC<{ children: JSX.Element }> = ({ children }) => {
  const clientKey = React.useMemo(() => getAmplitudeClientKey(), []);

  if (!clientKey) {
    // TODO: Amplitude environment key add to variable environment
    console.warn('AMPLITUDE_EXPERIMENT_ENVIRONMENT_KEY not found');
    return children;
  }

  const AMPLITUDE_EXPERIMENT_ENVIRONMENT_KEY = clientKey;

  return (
    <AmplitudeExperimentProvider
      envExperimentKey={AMPLITUDE_EXPERIMENT_ENVIRONMENT_KEY}
    >
      {children}
    </AmplitudeExperimentProvider>
  );
};

export default ExperimentLayout;

export function WithExperimentLayout<TProps>(Component: FC<TProps>) {
  return (props: TProps) => {
    return (
      <ExperimentLayout>
        <Component {...props} />
      </ExperimentLayout>
    );
  };
}
